import { Button } from "@common/components/ui/button"

export function ListEmpty({
  icon: Icon,
  title,
  body,
  onClear,
  action,
}: {
  icon: React.ComponentType<{ className?: string }>
  title: string
  body: string
  onClear?: () => void
  action?: React.ReactNode
}): React.ReactElement {
  return (
    <div className="flex min-h-64 items-center justify-center px-8 py-12">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <Icon className="h-8 w-8 text-muted-foreground" />
        <h2 className="text-h2">{title}</h2>
        <p className="text-body-medium text-muted-foreground">{body}</p>
        {onClear && (
          <Button variant="outline" size="sm" onClick={onClear}>
            Clear filters
          </Button>
        )}
        {action}
      </div>
    </div>
  )
}
